
import DrawBase from "../DrawBase"
import EditPolylineVolume from "./EditPolylineVolume"
//https://sandcastle.cesium.com/index.html?src=Polyline%2520Volume.html
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawPolylineVolume extends DrawBase {

    constructor(options) {
        super(options);
    }

    getEditInterface() {
        return EditPolylineVolume;
    }

    getTypeName() {
        return "管道";
    }

    getType() {
        return "polylineVolume_Nor";
    }

    checkMouseMove() {
        if (this.positionsTemp.length < 1) {
            return false;
        }
        return true;
    }


    computeCircle(radius) {
        const positions = [];
        for (let i = 0; i < 360; i+=6) {
            const radians = Cesium.Math.toRadians(i);
            positions.push(
                new Cesium.Cartesian2(
                    radius * Math.cos(radians),
                    radius * Math.sin(radians)
                )
            );
        }
        return positions;
    }


    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var positionsProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
                return positionsArr;
            }
            return $this.calcGlobeHeight(positionsArr ? positionsArr : $this.positions);
        }, false);

        var polylineVolume = this.createPolylineVolume(positionsProperty, $this.computeCircle(10));
        entity.polylineVolume = polylineVolume;
    }

    loadDynamicGraph(entity, data) {
        var $this = this;
        var positionsArr = JSON.parse(data.editPositions);
        var positionsProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
                return positionsArr;
            }
            return $this.calcGlobeHeight(positionsArr);
        }, true);
        var polylineVolume = this.createPolylineVolume(positionsProperty, $this.computeCircle(10));
        entity.polylineVolume = polylineVolume;
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "polylineVolume")
    }

}

export default DrawPolylineVolume